import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LimitationScreenService {
  constructor(private http: HttpClient) {}

  loadJsonObject(baseUrl: string, params: any): Observable<any> {
    const merged = { ...(params || {}) };
    const query = Object.keys(merged)
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(merged[k] == null ? '' : merged[k])}`)
      .join('&');
    return this.http.get<any>(`${baseUrl}/loadJsonObject?${query}`, { withCredentials: true });
  }

  saveObject(baseUrl: string, actionCode: string, globalParams: any, filterParams: any, settingsObj: any[], rows: any[], processName: string): Observable<any> {
    const payload = {
      ...(globalParams || {}),
      ...(filterParams || {}),
      jsonObj: JSON.stringify(rows || []),
      jsonSetting: JSON.stringify(settingsObj || []),
      process_name: processName,
    };
    const encoded = new URLSearchParams();
    Object.keys(payload).forEach((k) => {
      const value = payload[k];
      if (value !== undefined && value !== null) {
        encoded.set(k, typeof value === 'object' ? JSON.stringify(value) : String(value));
      }
    });
    return this.http.post<any>(`${baseUrl}/saveJsonObject?action_code=${actionCode}`, encoded.toString(), {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true,
    });
  }
}
